export const classes = {
  card: 'w-full flex flex-col rounded-2xl border border-solid border-black/10 bg-white/90 shadow-aurora-card px-[15px] pt-[14px] pb-3 dark:border-white/10 dark:bg-[#3a3547]',
  buttonsWrapper: 'place-between pt-3',
  withAttachments: 'pt-1',
  button: 'py-1',
  cancel: 'text-taupe-2 dark:text-mauve-2',
  menuButton: 'mx-2',
  saveWrapper: 'flex items-center',
  textField: 'w-full',
};

export const styles = {
  removeWrapper: {
    backgroundColor: 'hsla(210, 20%, 15%, 0.5)',
  },
};
